import type {historyLineItem} from '@/types/order'
import axios from './orderInstance'

// Errors propagate so the caller can show what actually went wrong -- swallowing them
// into `null` collapsed a bad id, a permission problem and an outage into one
// indistinguishable "unable to load".
export default async (orderId: string): Promise<historyLineItem[]> => {
    const response = await axios.get<historyLineItem[]>(`/orders/${orderId}/history`)
    return response.data
}
